import styled, { css } from "styled-components";
import { UIFont, FontFamily, FontWeight, UIColor } from "../types";

export const Button = styled.button<{ font?: UIFont }>`
  font-family: ${({ font: { family = FontFamily.HarmoniaSansStd } = {} }) =>
    family};
  font-weight: ${({ font: { weight = FontWeight.SemiBold } = {} }) => weight};
  font-size: ${({ theme }) =>
    theme.isMobile ? theme.getFontSize(14) : theme.getFontSize(22)}px;
  line-height: 1;
  padding: ${({ theme }) =>
    theme.isMobile
      ? `${theme.getValue(6)}px ${theme.getValue(10)}px`
      : `${theme.getValue(9)}px ${theme.getValue(24)}px ${theme.getValue(
          8,
        )}px`};
  text-align: center;
  cursor: pointer;
  border-radius: ${({ theme }) => theme.getValue(28)}px;
  appearance: none;
`;

export const PrimaryButton = styled(Button)<{
  textColor?: UIColor;
  backgroundColor?: UIColor;
  borderColor?: UIColor;
  hover?: {
    textColor?: UIColor;
    backgroundColor?: UIColor;
    borderColor?: UIColor;
  };
}>`
  color: ${({ theme, textColor }) => textColor?.hex || theme.colors.white};
  background: ${({ theme, backgroundColor }) =>
    backgroundColor?.hex || theme.colors.green2};
  border-width: ${({ theme }) =>
    theme.isMobile ? theme.getValue(2) : theme.getValue(3)}px;
  border-style: solid;
  border-color: ${({ theme, borderColor }) =>
    borderColor?.hex || theme.colors.green2};
  transition: all 0.2s;

  ${({ theme, hover }) =>
    hover
      ? css`
          &:hover {
            color: ${hover?.textColor?.hex || theme.colors.white};
            background: ${hover?.backgroundColor?.hex || theme.colors.green2};
            border-color: ${hover?.borderColor?.hex || theme.colors.green2};
          }
        `
      : ""};
`;
